// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"498":"c7b9ab65","513":"6234d603","703":"e87620f6","787":"c4e7f8f9"}[chunkId] + ".chunk.js";
};